if (!customElements.get('upload-artwork')) {
  customElements.define(
    'upload-artwork',
    class UploadArtWork extends HTMLElement {
      constructor() {
        super();

        this._status = 'waiting';
        this.maxFileSizeInMB = 100 * 1024 * 1024;

        this.index = -1;
        this.uploaded = [];
        this.instructions = [];

        this.imgContent = this.querySelector('.image-content');
        this.iframeContent = this.querySelector('.iframe-content');
        this.svgContent = this.querySelector('.svg-content');
        this.uploadBtns = this.querySelectorAll('.upload-btn');

        this.textCounter = this.querySelector('.text-counter');

        this.pagination = this.querySelector('.upload-paginator');
        if (this.pagination) {
          this.paginationLabel = this.pagination.querySelector('.center-text');
        }

        this.formContainer = this.querySelector('.upload-form');
        this.toastUploadDiv = '';
        this.uploadBtns.forEach((input) =>
          input.addEventListener(
            'change',
            () => this.handleUpload(input),
            false,
          ),
        );

        this.removeBtn = this.querySelector('.btn-remove');
        if (this.removeBtn) {
          this.removeBtn.addEventListener('click', () => {
            this.removeUpload();
          });
        }

        this.note = this.querySelector('textarea');
        if (this.note) {
          this.note.addEventListener('input', () => {
            this.textCounter.textContent = 500 - this.note.value.length;
            this.instructions[this.index] = this.note.value;
          });
        }

        this.prevBtn = this.querySelector('.pagination-button.prev');
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.prevUpload();
          });
        }

        this.nextBtn = this.querySelector('.pagination-button.next');
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.nextUpload();
          });
        }
      }

      get active() {
        return this.uploaded[this.index];
      }

      get status() {
        return this._status;
      }

      set status(status = 'waiting') {
        this._status = status;

        this.refresh();
      }

      refresh() {
        this.classList.remove('loaded');
        this.classList.remove('loading');
        if (this.status === 'loading') this.classList.add('loading');
        else if (this.status === 'loaded') this.classList.add('loaded');

        /* Preview Current Item */
        if (this.status === 'loaded' && this.uploaded.length) {
          this.imgContent.classList.add('hidden');
          this.iframeContent.classList.add('hidden');
          this.svgContent.classList.add('hidden');

          if (this.active.secure_url.includes('.pdf')) {
            this.iframeContent.src = this.active.secure_url;
            this.iframeContent.classList.remove('hidden');
          } else if (this.active.secure_url.includes('.svg')) {
            this.svgContent.src = this.active.secure_url;
            this.svgContent.classList.remove('hidden');
          } else {
            this.imgContent.style.backgroundImage = `url(${this.active.secure_url})`;
            this.imgContent.classList.remove('hidden');
          }

          this.note.value = this.instructions[this.index];
          this.note.dispatchEvent(new Event('input'));

          /* Pagination */
          if (this.uploaded.length > 1) {
            this.paginationLabel.textContent = `${this.index + 1} of ${
              this.uploaded.length
            }`;
            this.pagination.classList.remove('hidden');
          } else this.pagination.classList.add('hidden');
        }
      }

      async handleUpload(input) {
        try {
          this.status = 'loading';

          for (let file of input.files) {
            if (file.size < this.maxFileSizeInMB) {
              const formData = new FormData();
              formData.append('file', file);
              formData.append('upload_preset', 'rnxozoqn');

              const data = await fetch(
                'https://api.cloudinary.com/v1_1/arka/upload',
                {
                  method: 'POST',
                  body: formData,
                },
              ).then((res) => res.json());

              if (
                data.resource_type === 'image' &&
                data.image_metadata.DPI < 300 &&
                data.format != 'svg'
              ) {
                throw new Error(
                  'Upload failed. File must be at least 300 dpi.',
                );
              }

              this.uploaded.push(data);
              this.instructions.push('');
            }
          }

          this.index =
            this.uploaded.length > input.files.length
              ? this.uploaded.length - input.files.length - 1
              : 0;

          this.status = 'loaded';
          this.showToast('Uploaded succesfully', 'success');
        } catch (error) {
          this.status = 'loaded';
          this.showToast(error.message, 'error');
        }
      }

      removeUpload() {
        fetch('https://api.cloudinary.com/v1_1/arka/delete_by_token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            token: this.active.delete_token,
          }),
        });

        this.uploaded.splice(this.index, 1);
        this.instructions.splice(this.index, 1);

        if (this.uploaded.length < 1) this.status = 'waiting';
        else if (this.index > this.uploaded.length - 1) this.prevUpload();
        else this.refresh();
      }

      prevUpload() {
        if (this.index > 0) this.index--;
        else if (this.index === 0 && this.uploaded.length > 0)
          this.index = this.uploaded.length - 1;

        this.refresh();
      }

      nextUpload() {
        if (this.index < this.uploaded.length - 1) this.index++;
        else if (this.index === this.uploaded.length - 1) this.index = 0;

        this.refresh();
      }

      showToast(text, type) {
        if (this.formContainer.querySelector('#toast-upload')) {
          this.formContainer.removeChild(
            this.formContainer.querySelector('#toast-upload'),
          );
        }

        if (this.classList.contains('loaded')) {
          if (type === 'success') {
            this.toastUploadDiv = document.createElement('div');
            this.toastUploadDiv.setAttribute('id', 'toast-upload');
            this.formContainer.appendChild(this.toastUploadDiv);

            this.toastUploadDiv.textContent = text;
            this.toastUploadDiv.style.backgroundColor = '#4BB543';
            this.toastUploadDiv.classList.add('show');

            setTimeout(() => {
              this.toastUploadDiv.classList.remove('show');
              this.formContainer.removeChild(this.toastUploadDiv);
            }, 3000);
          }

          if (type === 'error') {
            this.toastUploadDiv = document.createElement('div');
            this.toastUploadDiv.setAttribute('id', 'toast-upload');
            this.formContainer.appendChild(this.toastUploadDiv);

            this.toastUploadDiv.textContent = text;
            this.toastUploadDiv.style.backgroundColor = '#e74c3c';
            this.toastUploadDiv.classList.add('show');
          }
        }
      }
    },
  );
}
